module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-37.b01e194e.png";